<template>
	<view class="box">
		<view class="title">
			<image src="/static/icon/diancan_ic_success@2x.png" mode="widthFix"></image>
			<text>支付成功</text>
		</view>
		<view class="info">可在个人中心“我的订单”页面查看</view>
		<view class="btns">
			<view class="btns-a">回到首页</view>
			<view class="btns-b">查看订单</view>
		</view>
		<view class="data">
			<view class="data-title">自提码</view>
			<view class="data-qrcode">
				<image src="/static/logo.png" mode="widthFix"></image>
			</view>
			<view class="data-a">38389</view>
			<view class="data-b">点击复制自提码</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 0 40rpx;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		.title {
			display: flex;
			align-items: center;
			margin-top: 82rpx;
			image {
				width: 40rpx;
				height: 40rpx;
				margin-right: 14rpx;
			}
			text {
				font-weight: 500;
				font-size: 30rpx;
				color: #333333;
			}
		}
		.info {
			font-weight: 400;
			font-size: 24rpx;
			color: #999999;
			margin-top: 40rpx;
		}
		.data {
			width: 100%;
			padding: 60rpx 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background: #F8F9FB;
			margin-top: 80rpx;
			border-radius: 24rpx;
			.data-title {
				font-weight: 500;
				font-size: 34rpx;
				color: #222222;
			}
			.data-a {
				font-weight: 600;
				font-size: 36rpx;
				color: #222222;
				margin-top: 32rpx;
			}
			.data-b {
				font-weight: 400;
				font-size: 24rpx;
				color: #999999;
				margin-top: 24rpx;
			}
			.data-qrcode {
				width: 360rpx;
				height: 360rpx;
				margin-top: 40rpx;
				image {
					width: 100%;
				}
			}
		}
		.btns {
			display: flex;
			margin-top: 60rpx;
			align-items: center;
			.btns-a {
				width: 260rpx;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				background: #FFFFFF;
				border-radius: 50rpx;
				font-weight: 400;
				font-size: 30rpx;
				color: #666666;
				border: 1rpx solid #CCCCCC;
				margin-right: 40rpx;
			}
			.btns-b {
				width: 260rpx;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				background: #FFFFFF;
				border-radius: 50rpx;
				font-weight: 400;
				font-size: 30rpx;
				color: #004096;
				border: 1rpx solid #004096;
			}
		}
	}
</style>